import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UpgradeComponent } from './upgrade.component';
import { FormsModule }   from '@angular/forms';
import {PaymentModule} from "../payment/payment.module";
import { SharedModule } from '../shared/shared.module';

@NgModule({
    imports: [CommonModule, FormsModule, PaymentModule, SharedModule],
    declarations: [UpgradeComponent],
    exports: [UpgradeComponent]
})

export class UpgradeModule { }
